module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am770-916743c8848654aa98e062c4a1ab6df4.jpg";